import React from 'react';
// @ts-ignore
import { Heading, HorizontalRule, Loader } from 'arag-ui-lib';
import ClaimOverview from '../claimOverview/claimOverview';
import ClaimTabArea from '../claimTabArea/claimTabArea';
import WithdrawClaimApplicationModal from '../withdrawClaimApplicationModal/withdrawClaimApplicationModal';
import DisplayDocumentClickedByEmailLink from '../displayDocumentClickedByEmailLink/displayDocumentClickedByEmailLink';
import i18n from '../../i18n/i18n';
import { useTranslation } from 'react-i18next';

type Props = {
    claimApplication: any;
    fetchingClaim: boolean;
    openWithdrawModal: () => void;
    closeWithdrawModal: () => void;
    isWithdrawnModalOpen: boolean;
    withDrawQuestions: Array<any>;
    submittingWithdrawnClaim: boolean;
    questionTypes: { [id: string]: any } | null;
    onSubmitWithDrawnClaimApplication: (formAnswers: any) => void;
    openDocumentModal: boolean;
    onCloseDocumentModal: () => void;
    claimApplicationTemplate: { content: string } | null;
};

const ExistingClaim = (props: Props): JSX.Element | null => {
    const {
        claimApplication,
        fetchingClaim,
        openWithdrawModal,
        closeWithdrawModal,
        isWithdrawnModalOpen,
        withDrawQuestions,
        submittingWithdrawnClaim,
        questionTypes,
        onSubmitWithDrawnClaimApplication,
        openDocumentModal,
        onCloseDocumentModal,
        claimApplicationTemplate,
    } = props;

    const { t } = useTranslation();

    if (fetchingClaim) {
        return <Loader />;
    }

    if (!claimApplication) {
        return null;
    }

    return (
        <div>
            <Heading
                variant="h2"
                title={`${t('claim')} ${claimApplication.claimReference}`}
            />
            <ClaimOverview
                openWithdrawModal={openWithdrawModal}
                claimApplication={claimApplication}
            />
            <HorizontalRule />
            <ClaimTabArea claimApplication={claimApplication} />
            <WithdrawClaimApplicationModal
                isWithdrawnModalOpen={isWithdrawnModalOpen}
                closeWithdrawModal={closeWithdrawModal}
                claimApplication={claimApplication}
                withDrawQuestions={withDrawQuestions}
                submittingWithdrawnClaim={submittingWithdrawnClaim}
                questionTypes={questionTypes}
                onSubmitWithDrawnClaimApplication={
                    onSubmitWithDrawnClaimApplication
                }
            />
            <DisplayDocumentClickedByEmailLink
                openDocumentModal={openDocumentModal}
                onCloseDocumentModal={onCloseDocumentModal}
                claimApplicationTemplate={claimApplicationTemplate}
            />
        </div>
    );
};

export default ExistingClaim;
